module.exports = __webpack_public_path__ + "assets/users.c96f2c5bf7ca05dc45ce2e430a7b8e1c.svg";